import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import isPropValid from '@emotion/is-prop-valid'
import OnVisible from 'react-on-visible';
import { containers, Grid } from 'style';

class ListComponent extends PureComponent {
    constructor() {
        super();

        this.delayOffset = 0;
        this.delay = 0.1;
        this.onVisible = this.onVisible.bind(this);
        this.resetDelay = this.resetDelay.bind(this);
    }
    onVisible(el) {
        if (this.delayOffset > 10) {
            el.setDelay(0);
        } else {
            el.setDelay(this.delay * this.delayOffset);
        }
        this.delayOffset++;
        setTimeout(this.resetDelay, 10);
    }
    resetDelay() {
        this.delayOffset = 0;
    }
    render() {
        return (
            <Grid.InnerContainer id="ListComponent">
                <Grid.Row>
                    <Grid.Col>{this.props.children}</Grid.Col>
                </Grid.Row>
            </Grid.InnerContainer>
        );
    }
}

export class ItemComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.delay = 0;
        this.state = {
            delay: 0,
        };
    }
    setDelay(delay) {
        this.setState({ delay: delay });
    }
    render() {
        const { itemsPerRow, align, maxWidthMobile, isVisible } = this.props;
        return (
            <OnVisible
                percent={30}
                visibleClassName={'visible'}
                align={align}
                className={`col-xs-12 col-sm-4 ${isVisible === true ? 'visible' : ''}`}
                onChange={
                    this.props.onChange && this.props.onChange.bind(this, this)
                }
                style={{transitionDelay: `${this.state.delay}s`}}
                css={grid_item_wrapper_css}
                delay={this.state.delay}>
                {this.props.children}
            </OnVisible>
        );
    }
}

export const grid_item_wrapper_css = css`
    display:flex;
    align-items: flex-end; 

    transform: translateY(40px);
    opacity: 0.01;

    a {
        text-decoration: none;
    }
    &:after {
        content: '';
        flex: auto;
    }
    &.visible {
        transition: transform 0.5s ease-out, opacity 0.2s ease-out;
        transform: translateY(0);
        opacity: 1;
    }

    & > div {
        width: 100%;
    }
    margin-bottom: 4rem;

    @media (min-width: 38em){
    margin-bottom: 10%;
    }

`


// export const GridItemWrapper = styled(OnVisible, {
//     shouldForwardProp: prop =>
//         isPropValid(prop) && prop !== 'itemsPerRow'
// })`
    
// `;

// export const ListWrapper = styled.div`
//     display: flex;

//     flex-wrap: wrap;
//     flex: 1 1 auto;
//     /* margin: ${props => props.margin ? `0 -${props.margin * 2}%` : '-10px'}; */
//     justify-content: space-between;

//     @media (min-width: ${containers.medium}px) {
//       margin: ${props => props.margin ? `0 -${props.margin}vw` : '-10px'};
//       padding: ${props => props.padding ? `0 ${props.padding}%` : '-10px'};
//     }
//     @media (min-width: ${containers.innerPX + 60}px) {
//         /* margin: 0 -10px; */
//     }

// `;

export default ListComponent;
